// extracted by mini-css-extract-plugin
module.exports = {"inputGroup":"SelectForm_inputGroup__Aj_Ds"};